<div class="deactivation-decision-dialog">

  <h1 mat-dialog-title class="dialog-title">
    {{ isDecline ? 'Decline this request' : 'Mark pupil as exempt' }}
  </h1>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-message" *ngIf="isDecline">
      {{ data.pupilName }} will keep their LOQT account and stay an active pupil. Your reason is shared with the parent.
    </p>
    <p class="dialog-message" *ngIf="!isDecline">
      {{ data.pupilName }} stays on your roster but is exempt from LOQT. School restrictions no longer apply to them,
      and they are not chased as an unenrolled pupil.
    </p>

    <!-- DECLINE: the parent is owed an explanation -->
    <mat-form-field appearance="outline" class="full-width" *ngIf="isDecline">
      <mat-label>Reason for declining</mat-label>
      <textarea matInput rows="4" [(ngModel)]="reason" [maxlength]="maxReasonLength"
                placeholder="Tell the parent why this request is declined"></textarea>
      <mat-hint align="end">{{ trimmedReason.length }} / {{ maxReasonLength }}</mat-hint>
    </mat-form-field>
    <p class="field-error" *ngIf="reasonError">{{ reasonError }}</p>

    <!-- EXEMPT: reuses the school's existing exemption reasons -->
    <mat-form-field appearance="outline" class="full-width" *ngIf="!isDecline">
      <mat-label>Exemption reason</mat-label>
      <mat-select [(ngModel)]="exemptionReason">
        <mat-option *ngFor="let r of exemptionReasons" [value]="r">{{ exemptionReasonLabels[r] }}</mat-option>
      </mat-select>
    </mat-form-field>
    <p class="exemption-caveat" *ngIf="!isDecline && exemptionReasonCaveat">{{ exemptionReasonCaveat }}</p>

    <mat-form-field appearance="outline" class="full-width" *ngIf="!isDecline && showExemptionNote">
      <mat-label>Additional comment</mat-label>
      <input matInput [(ngModel)]="exemptionNote" [maxlength]="maxNoteLength"
             placeholder="Add any detail that explains the exemption">
      <mat-hint align="end">{{ trimmedNote.length }} / {{ maxNoteLength }}</mat-hint>
    </mat-form-field>
    <p class="field-error" *ngIf="noteError">{{ noteError }}</p>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="confirm()">
      {{ isDecline ? 'Decline request' : 'Mark as exempt' }}
    </button>
  </mat-dialog-actions>
</div>
